export default {
    name: '聚焦屏幕',
    studentMessage: '现在请集中注意力听老师讲课',
    teacherMessage: '正在使用聚焦屏幕。',
    close: '关闭',
};
